<ui-sidebar-layout [navItems]="items()" [sidebarEnabled]="isAuthenticated()">
  <ng-template #logo>
    <img
      [src]="links.logoSrc"
      [alt]="links.logoAlt"
      class="max-w-45 max-h-12"
    />
  </ng-template>
  <ng-template #toolbar>
    @if (isAuthenticated()) {
      <p-button
        icon="fa-regular fa-arrow-right-from-bracket"
        [text]="true"
        severity="contrast"
        (onClick)="logout()"
        [pTooltip]="'label.logout' | translate"
      ></p-button>
    }
  </ng-template>
  <ng-template #footer>
    <!-- A card-white band with the brand hairline, not `bg-surface-100`: surface.100 is the
         warm-sand app background itself, so the footer would render exactly the colour of the
         page behind it and stop reading as a footer at all. -->
    <footer class="bg-surface-0 border-t border-surface-200 p-4 mt-auto">
      <div class="container mx-auto">
        <a
          class="nav-item px-3 py-2 text-primary-500 font-bold"
          [href]="links.impressum"
          target="_blank"
          >{{ 'label.imprint' | translate }}</a
        >
      </div>
    </footer>
  </ng-template>
</ui-sidebar-layout>
